import React from 'react'
import { Box, Typography } from '@mui/material'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

import type { BlockPayload } from '../../../types'

const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['link'],
    ['clean'],
  ],
}

interface Props {
  payload: { html?: string }
  onChange: (payload: BlockPayload) => void
}

export const ContentBlock: React.FC<Props> = ({ payload: p, onChange }) => {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        แก้ไขเนื้อหาแบบ WYSIWYG
      </Typography>
      <Box
        sx={{
          '& .quill': { bgcolor: 'background.paper', borderRadius: 1 },
          '& .ql-container': { minHeight: 200, borderColor: 'divider' },
          '& .ql-toolbar': { borderColor: 'divider', borderRadius: '8px 8px 0 0' },
          '& .ql-editor': { minHeight: 200 },
        }}
      >
        <ReactQuill
          theme="snow"
          value={p?.html ?? ''}
          onChange={(html) => onChange({ html })}
          modules={quillModules}
        />
      </Box>
    </Box>
  )
}
